import { Button, Card, Col, Form, Row } from "react-bootstrap";
import AddonsDetails from "./AddonsDetails";
import UseToggle from "../../../Hooks/UseToggle";
import { useState } from "react";

const addonsData = [
  {
    addonId: "9141455186",
    banners: [
      "https://password-super.s3.ap-south-1.amazonaws.com/icons/removebranding1.png",
      "https://password-super.s3.ap-south-1.amazonaws.com/icons/removebranding2.png",
      "https://password-super.s3.ap-south-1.amazonaws.com/icons/removebranding3.png",
      "https://password-super.s3.ap-south-1.amazonaws.com/icons/removebranding4.png",
      "https://password-super.s3.ap-south-1.amazonaws.com/icons/removebranding5.png",
    ],
    chatWithUs: true,
    createdAt: "2026-01-27T13:25:07.764Z",
    createdBy: "9687457898",
    faqType: true,
    faqs: [
      {
        answer:
          '"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat."',
        question:
          'How does the Hire Live Agents add-on work?',
      },
      {
        answer:
          '"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat."',
        question:
          'How does the Hire Live Agents add-on work?',
      },
      {
        answer:
          '"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat."',
        question:
          'How does the Hire Live Agents add-on work?',
      },
      {
        answer:
          '"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat."',
        question:
          'How does the Hire Live Agents add-on work?',
      },
    ],
    hourlyPrice: 0.5,
    icon: "https://password-super.s3.ap-south-1.amazonaws.com/icons/removebranding.png",
    lockStatus: false,
    monthlyPrice: 19.0,
    overview: 
      "Truly customize the tawk.to widget and email and create a more professional messaging experience for your visitors by removing or replacing the tawk.to brand with your own.",
    scheduleCall: false,
    shortDescription:
      "Truly customize the tawk.to widget and email and create a more professional messaging experience for your visitors by removing or replacing the tawk.to brand with your own.",
    sliders: true,
    status: "draft",
    tags: ["logo", "Branding "],
    title: "Remove Branding",
    updatedAt: "2026-01-29T12:25:02.881Z",
    updatedBy: "9687457898",
    yearlyPrice: 122.0,
    __v: 0,
    _id: "6978bcb3393a87a26b1d4455",
  },
];

const Addons = () => {
  const toggles = UseToggle();
  const [addonData, setAddonData] = useState(null);

  return (
    <>
      <div className="h-100">
        <div className="flex-grow-1 overflow-auto p-4">
          <Row className="g-3">
            {addonsData.map((item) => (
              <Col key={item._id} xxl={3} xl={4} lg={6} md={6} sm={12}>
                <Card
                  className="border h-100 addon-card CP"
                  onClick={() => {
                    setAddonData(item);
                    toggles.setToggle();
                  }}
                >
                  <div className="addon-img-wrapper">
                    <Card.Img
                      src={item?.banners?.[0]}
                      alt={item.title}
                      className="addon-img"
                    />
                    <div className="addon-overlay-text">Learn more</div>
                  </div>

                  <Card.Body className="d-flex flex-column">
                    <Card.Title>{item.title}</Card.Title>

                    <Card.Text className="text-muted" style={{ fontSize: 13 }}>
                      {item.shortDescription}
                    </Card.Text>

                    <div className="hstack justify-content-between gap-2 mt-auto">
                      <Form.Label className="m-0 fw-semibold">
                        ${item.monthlyPrice} / month
                      </Form.Label>

                      <Button size="sm" variant="primary">
                        Activate Now
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </div>

      <AddonsDetails
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        addonData={addonData}
      />
    </>
  );
};

export default Addons;
